import PropTypes from 'prop-types';

export const FavoriteListPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  name: PropTypes.string.isRequired,
  isDefault: PropTypes.bool.isRequired,
  stationIds: PropTypes.arrayOf(PropTypes.number).isRequired,
});
